/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import User from '../models/userModel';
import Account from '../models/accountModel';

export function setBeaconIds(user: User, account: Account | null) {
    if (user.isDemoAccount) return clearBeaconIds();
    const customerId = getCustomerID(user);
    const identity = {
        'account-id': account?.id,
        'user-id': user.id,
        'customer-id': customerId,
        'email': user.email,
        'name': user.fullName,
        'company-name': account?.selectablePlatformLabel,
        'subscription': user.subscription?.statusLabel
    };
    window.Beacon('identify', identity);
}

export function clearBeaconIds() {
    window.Beacon('identify', {
        'account-id': '',
        'user-id': '',
        'email': '',
        'name': '',
        'customer-id': '',
        'company-name': '',
        'subscription': ''
    });
}

export function hideBeacon() {
    window.Beacon('destroy');
}

export function showBeacon() {
    window.Beacon('open');
}

export function setBeaconDisplay(display: 'message' | 'docs') {
    const route = display === 'message' ? '/ask/message/' : '/answers/';
    window.Beacon('navigate', route);
}

export function setBeaconMessage(subject: string, text: string) {
    window.Beacon('navigate', '/ask/message/');
    window.Beacon('prefill', {
        subject, text
    });
}

function getCustomerID(user: User | null): string | null {
    return user?.subscription?.customerId ?? null;
}